// this is an autogenerated file from DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Documents/Content/SystemFiles/FilesTree/Documents/Body/Content/Document/File/query.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_CommsThread_Content_MessageTools_External_Tools_AttachmentAction_InApp_Documents_Content_SystemFiles_FilesTree_Documents_Body_Content_Document_File(
  $resource_id: StringOrNumber!
  $resource_type: vaxiom_resource_object_meta_resource_type!
) {
  vaxiom_resource_object_meta(
    resource_id: $resource_id
    resource_type: $resource_type
  ) {
    name
    content_type
    size
    preview_url
  }
}

`